module.exports = __webpack_public_path__ + "media/common/images/innogy_style/people-bb64dae8b006b330230441a8aa6b74f5.svg";